<template>
    <div class="is-marginless" @click.stop>
        <div class="intro px-4 py-4">
            <p class="is-size-6 has-text-black">
                {{
                    $t(
                        'projectCommunicationThread.comunication_thread_description'
                    )
                }}
            </p>
        </div>
        <div class="lb-separator" />
        <div class="">
            <div
                :class="
                    canAddComment
                        ? 'lb-project-comments'
                        : 'lb-project-comments is-full-list'
                "
                class="pt-3 pl-2"
            >
                <div
                    v-for="(comment, index) in projectComments"
                    :ref="comment._id"
                    :key="comment._id"
                    :class="{
                        'has-background-light':
                            comment.sending || comment.editing,
                        'has-background-danger-light': comment.deleted,
                    }"
                    class="comment"
                >
                    <comment
                        class="project-comment"
                        :dropdown="index == 0"
                        :comment="comment"
                        @like="toggleLike(comment._id)"
                        @edit="editComment(comment)"
                        @delete="deleteComment(comment)"
                    />
                    <div class="lb-separator mt-2" />
                </div>
            </div>
            <section class="lb-comment-input-container">
                <app-message-input-bar
                    class="lb-project-thread-input lb-clean-input"
                    @comment="sendComment"
                />
            </section>
        </div>
    </div>
</template>

<script>
import {
    addComment,
    updateComment,
    deleteComment,
    likeProjectComment,
} from '@/services/API';
import AppMessageInputBar from '@/components/AppMessageInputBar';
import ProjectConfigurationComment from '@/components/ProjectConfigurationComment';
import _ from 'underscore';
export default {
    components: {
        AppMessageInputBar,
        Comment: ProjectConfigurationComment,
    },
    props: {
        contentOwner: {
            type: Object,
            default: () => {
                return {};
            },
        },
        objectId: {
            type: String,
            default: () => {
                return '';
            },
        },
    },
    data() {
        return {
            slideUp: false,
            slideDown: true,
        };
    },
    computed: {
        canAddComment() {
            if (!this.$store.getters.canCommentInProject) {
                return false;
            }
            if (this.$store.getters.project.privacy == 'organization') {
                if (
                    this.$store.getters.isTeacher ||
                    this.$store.getters.isStudent
                ) {
                    return (
                        this.$store.getters.project.owner.school._id ===
                        this.$store.getters.user.school._id
                    );
                }
            }
            if (this.$store.getters.isAnonymous) {
                return false;
            }
            return this.$store.getters.project.accessLevel != 'read';
        },
        projectComments() {
            return this.$store.getters.projectComments;
        },
        projectCommentsLength() {
            return this.projectComments.length;
        },
    },
    watch: {
        projectCommentsLength: {
            handler: function (newComments, oldComments) {
                this.scrollToItem();
            },
        },
    },
    mounted() {
        this.$store.dispatch('fetchProjectComments');
    },
    methods: {
        async toggleLike(commentId) {
            let likeResult = await likeProjectComment(commentId);
            this.$store.commit('UPDATE_COMMENT', {
                _id: commentId,
                comment: likeResult.data,
            });
        },
        sendComment(text) {
            let message = {
                message: text,
                owner: this.$store.getters.user,
                created: Date.now(),
                sending: true,
            };
            addComment('project', this.objectId, {
                message: text,
            })
                .then((result) => {
                    message.sending = false;
                    this.$store.dispatch('fetchProjectComments');
                })
                .catch((e) => {
                    message.error = true;
                    console.log('error', e);
                })
                .finally(() => {
                    message.sending = false;
                });
        },
        updateComment(comment) {
            updateComment('project', this.objectId, comment)
                .then((result) => {
                    // this.$store.dispatch("fetchProjectComments");
                    this.$store.commit('UPDATE_COMMENT', {
                        _id: comment._id,
                        comment: result.data,
                    });
                })
                .catch((e) => {
                    console.log('error', e);
                });
        },

        editComment(comment) {
            this.updateComment(comment);
        },

        deleteComment(comment) {
            deleteComment('project', this.objectId, comment._id).finally(() => {
                this.$store.dispatch('fetchProjectComments');
            });
        },
        scrollToItem() {
            const lastMessage = _.last(this.projectComments);
            if (lastMessage) {
                this.$nextTick(() => {
                    this.$refs[lastMessage._id][0].scrollIntoView();
                });
            }
        },
    },
};
</script>

<style scoped>
.project-comment /deep/ .media {
    padding-left: 0.5rem !important;
    padding-bottom: 0.25rem !important;
}
.project-comment /deep/ .media-right {
    padding-right: 1rem !important;
}
.project-comment /deep/ .comment-content {
    padding-right: 1rem !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
    font-size: 0.9rem;
}

.lb-comment-input-container {
    margin: 0 !important;
    padding-right: 2rem;
}

.lb-comment-input-container /deep/ .lb-grow,
.lb-comment-input-container /deep/ .lb-grow > textarea,
.lb-comment-input-container /deep/ button {
    height: 60px !important;
}

.lb-project-comments {
    max-height: calc(100vh - 15.2rem);
    height: calc(100vh - 15.2rem);
    overflow: hidden;
    overflow-y: auto;
    margin-right: 0;
}

.comments-header {
    padding-bottom: 0.5rem;
    cursor: pointer;
}

.comment {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

.slide-up,
.slide-down {
    overflow: hidden;
}
.slide-up > div,
.slide-down > div {
    transform: translateY(-100%);
    transition: 0.4s ease-in-out;
    height: 0;
}
.slide-down > div {
    transform: translateY(0);
    height: 100%;
}

.lb-likes-count {
    vertical-align: top;
}

.lb-message-input input {
    background-color: pale-grey;
}
</style>
